import { api } from "./config";

// ── Slip bot admin API (/api/slipbot — OCR history + settings) ──────────────

export async function getSlipBotEvents({ page = 1, limit = 20, outcome = "", search = "", dateFrom = "", dateTo = "" } = {}) {
  try {
    const params = new URLSearchParams({ page, limit });
    if (outcome) params.append("outcome", outcome);
    if (search) params.append("search", search);
    if (dateFrom) params.append("dateFrom", dateFrom);
    if (dateTo) params.append("dateTo", dateTo);
    const res = await api().get(`/slipbot/events?${params.toString()}`);
    return res.data;
  } catch (error) {
    return error.response?.data || { success: false, message: error.message };
  }
}

// Evidence image URL (same-origin; httpOnly auth cookie is sent automatically).
export const slipBotMediaUrl = (filename) =>
  filename ? `${api().defaults.baseURL || ""}/slipbot/media/${filename}` : "";

export async function getSlipBotSettings() {
  try {
    const res = await api().get("/slipbot/settings");
    return res.data;
  } catch (error) {
    return error.response?.data || { success: false, message: error.message };
  }
}

export async function updateSlipBotSettings(matchCurrencies) {
  try {
    const res = await api().put("/slipbot/settings", { matchCurrencies });
    return res.data;
  } catch (error) {
    return error.response?.data || { success: false, message: error.message };
  }
}

// ── Manual-decision actions (OCR History detail dialog) ──────────────────────

// Staff confirms a bot-missed image really is a bank slip — creates AND
// auto-approves a WalletTopupRequest reusing the event's evidence photo.
export async function createManualTopup(eventId, { amount, currency, note }) {
  try {
    const res = await api().post(`/slipbot/events/${eventId}/create-topup`, { amount, currency, note });
    return res.data;
  } catch (error) {
    return error.response?.data || { success: false, message: error.message };
  }
}

// Logs a staff decision against a SlipBotEvent (audit trail only — no money
// movement). Call AFTER the corresponding wallet action (reject/reverse)
// already succeeded, or standalone for "confirmed_correct".
export async function reviewSlipBotEvent(eventId, { action, note }) {
  try {
    const res = await api().post(`/slipbot/events/${eventId}/review`, { action, note });
    return res.data;
  } catch (error) {
    return error.response?.data || { success: false, message: error.message };
  }
}
